import { render, staticRenderFns } from "./deleteSign.vue?vue&type=template&id=30f5332a&"
import script from "./deleteSign.vue?vue&type=script&lang=js&"
export * from "./deleteSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports